<template>
  <span
    class="v-icon"
    :style="iconStyle"
    v-html="svgContent"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'VIcon',
  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 14 },
    color: { type: String, default: 'currentColor' }
  },
  computed: {
    svgContent() {
      return require(`!!html-loader!../../../static/icons/${this.name}.svg`);
    },
    iconStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        color: this.color
      };
    }
  }
}
</script>

<style scoped>
.v-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.v-icon >>> svg {
  width: 100% !important;
  height: 100% !important;
  fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/VIcon.vue